//import React from 'react';
import useTranslations from '@/apps/providers/useTranslations';

/**
 * ChatHeader - Header bar for chat widget
 * Shows business name, language switcher, and close button
 */
function ChatHeader({ onClose, business }) {
  const { tr, locale, setLocale } = useTranslations();

  const handleLanguageToggle = () => {
    // Toggle between en_US and es_CO
    const newLocale = locale === 'es_CO' ? 'en_US' : 'es_CO';
    setLocale(newLocale);
  };

  const getLanguageLabel = () => {
    return locale === 'es_CO' ? 'ES' : 'EN';
  };

  return (
    <div className="chat-header">
      <div className="chat-header-info">
        <div className="chat-avatar">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2 2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
            <rect x="3" y="8" width="18" height="12" rx="2" />
          </svg>
        </div>
        <div className="chat-header-text">
          <div className="chat-title">{tr('chat.header.title')}</div>
          {business && (
            <div className="chat-subtitle">{business.name}</div>
          )}
        </div>
      </div>

      <div className="chat-header-actions">
        {/* Language Switcher */}
        <button
          className="chat-language-btn"
          onClick={handleLanguageToggle}
          aria-label={tr('chat.language.switch')}
          title={tr('chat.language.switch')}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M5 8l6 6" />
            <path d="M5 12l6 6" />
            <path d="M5 16l6 6" />
            <path d="M11 5h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-6" />
          </svg>
          <span className="chat-language-label">{getLanguageLabel()}</span>
        </button>

        {/* Close Button */}
        <button
          className="chat-close-btn"
          onClick={onClose}
          aria-label={tr('chat.header.close')}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default ChatHeader;
